/* eslint-disable vars-on-top */

var $ = require('jquery');

require('../utils/videojs')();
require('inobounce'); // BSDDEV-327 fix scrolling on iOS devices, patch at module needed -> see Webpack config

var cookies = require('./cookie');
var offcanvasdialog = require('./offcanvasdialog');
var privacy = require('./product/privacy');
var privacyOverlay = require('./privacy-overlay');
var teaser = require('./teaser');
var toggle = require('./toggle');
var tracking = require('./tracking/tracking');
var header = require('./header/header');
var util = require('../utils/util');
var page = require('./page');
var uniform = require('../components/uniform');
var footerIconsSprite = require('./footer/footer-icons-sprite');
var addMaximumScaleToViewport = require('../utils/addMaximumScaleToViewport');
var liveChatPilot = require('../widgets/liveChatPilot');
var geoIpCountrySwitcher = require('./geoIpCountrySwitcher');
const googleRecaptcha = require('./googleRecaptcha');
const universalLink = require('../utils/universalLink.js');
const recommendationsWidgets = require('../pages/optimizelyRecommendationsWidgets');
const optiExperiment = require('../components/optimizelyExperimentation');

let hasScrollEventFired = false;

import {debounce} from '../components/custom-lodash';

// enable frontend JS logging
(function () {
    if (clientErrorLogging) {
        // eslint-disable-next-line no-undef
        require('../utils/logger')(clientErrorLogging);
    }
})();

// general extension functions
(function () {
    String.format = function () {
        var first = 0;
        var str = arguments[first];
        var i;
        var len = arguments.length - 1;
        var reg;
        for (i = 0; i < len; i++) {
            reg = new RegExp('\\{' + i + '\\}', 'gm');
            str = str.replace(reg, arguments[i + 1]);
        }
        return str;
    };
})();

module.exports.init = function () {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];
    var $subscribeEmail;

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            var text = $.trim($(this).val());
            var charsLimit = $(this).data('character-limit');
            var charsUsed = text.length;

            if (charsUsed >= charsLimit && controlKeys.indexOf(e.which.toString()) < 0) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            var text = $.trim($(this).val());
            var charsLimit = $(this).data('character-limit');
            var charsUsed = text.length;
            var charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).next('div.char-count').find('.char-remain-count').html(charsRemain);
        });

    // remove unused content areas
    $('.module-rebrush-grey').each(function () {
        if ($(this).children('.module-rebrush-inner').children().length === 0) {
            $(this).hide();
        }
    });

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // subscribe email box
    $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0) {
        $subscribeEmail
            .focus(function () {
                var $val = $(this.val());
                if ($val.length > 0 && $val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                    return; // do not animate when contains non-default value
                }

                $(this).animate({color: '#999999'}, 500, 'linear', function () {
                    $(this).val('').css('color', '#333333');
                });
            })
            .blur(function () {
                var val = $.trim($(this.val()));
                if (val.length > 0) {
                    return; // do not animate when contains value
                }
                $(this)
                    .val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                    .css('color', '#999999')
                    .animate({color: '#333333'}, 500, 'linear');
            });
    }

    // main menu toggle
    $('.menu-toggle').on('click', function () {
        $('#wrapper').toggleClass('menu-active');
    });

    $('.menu-category li .menu-item-toggle').on('click', function (e) {
        var $parentLi = $(e.target).closest('li');
        e.preventDefault();
        $parentLi
            .siblings('li')
            .removeClass('active')
            .find('.menu-item-toggle')
            .removeClass('fa-chevron-up active')
            .addClass('fa-chevron-right');
        $parentLi.toggleClass('active');
        $(e.target).toggleClass('fa-chevron-right fa-chevron-up active');
    });

    // set cookie and use this cookie to show/hide very-top-infobanner
    $('.very-infobanner-hide-button button').on('click', function () {
        var $mainWrapper = $('.main-wrapper');
        var $HeaderWrapper = $('.header-wrapper');
        $('.very-infobanner-wrapper').hide();
        $mainWrapper.css('padding-top', $HeaderWrapper.outerHeight());
        cookies.set('dwHideVeryTopInfobanner', true, {path: '/', expires: 30});
    });

    // Using for content asset find-store
    $('.content-find-store-input input').on('blur', function () {
        if ($(this).val() === '') {
            $('.content-find-store-input .error').show();
        }
    });

    // Using for content asset find-store
    $('.content-find-store-input input').on('keypress', function (e) {
        if (e.which === 13) {
            if ($(this).val() === '') {
                $('.content-find-store-input .error').show();
            } else {
                $('.content-find-store-input .error').hide();
                $('#content-find-store-form').submit();
            }
        } else {
            $('.content-find-store-input .error').hide();
        }
    });

    // Using for content asset find-store
    $('.content-find-store-input span').on('click', function () {
        var $input = $('.content-find-store-input input');
        if ($input.val() === '') {
            $('.content-find-store-input .error').show();
        } else {
            $('.content-find-store-input .error').hide();
            $('#content-find-store-form').submit();
        }
        $('#content-find-store-form').submit();
    });

    // auto complete for japanese zip code and prefection
    $('[data-jpzipcomplete-htmlname]').each(function () {
        require('./jpzipcomplete')($(this));
    });
    let pdpMain = $('#pdpMain');
    if (pdpMain.length && !util.isMobile()) {
        $(window).on('scroll', function () {
            if (hasScrollEventFired) {
                return;
            }
            let lastScrollTop = 0;
            let scrollTop = $(window).scrollTop();
            let windowHeight = $(window).height();
            let documentHeight = $(document).height();

            let scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;

            if (scrollPercentage >= 75 && scrollTop > lastScrollTop) {
                optiExperiment.trackEvent('scroll_rate_75');
                hasScrollEventFired = true;
            }
        });
    }

    geoIpCountrySwitcher.init(window.pageContext && window.pageContext.ns);
    universalLink.init();
};

/**
 * Admin can change content of content slot very-top-header-infobanner. So its height is dynamic
 * Calculate height of header-wrapper and set padding for main-wraper
 */
module.exports.changeMainWrapperPadding = function changeMainWrapperPadding() {
    var $window = $(window);
    var $HeaderWrapper = $('.header-wrapper');
    var $infoBannerWrapper = $('.very-infobanner-wrapper');
    var $countryGateway = $('.countrygateway');

    function applyPadding() {
        var headerHeight = $HeaderWrapper.outerHeight() - $countryGateway.outerHeight();
        if ($infoBannerWrapper.length) {
            $infoBannerWrapper.css('padding-top', headerHeight);
        }
    }
    $window.on('load', applyPadding);
    $window.on('resize orientationchange', debounce(applyPadding, 10));
};

module.exports.initCookiePrivacy = function initCookiePrivacy() {
    if (SitePreferences.ENABLE_COOKIE_RESTRICTION) {
        privacy.initPrivacySwitches();
        if (SitePreferences.ENABLE_COOKIE_BANNER) {
            privacyOverlay.initPrivacyOverlay();
        }
    }
};

module.exports.initializeEvents = function initializeEvents() {
    // add generic toggle functionality
    toggle.init();

    // add generic teaser functionality
    teaser.init();
    header.init();
    tracking.init();
    footerIconsSprite.init();
    liveChatPilot.init();
    googleRecaptcha.init();
    recommendationsWidgets.init();

    uniform();
};

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
module.exports.initializeDom = function initializeDom() {
    $.extend(page, window.pageContext);

    if (document.cookie.length === 0) {
        $('<div/>')
            .addClass('no-cookie-message')
            .append($('<div/>').addClass('no-cookie-message-inner').html(Resources.COOKIES_DISABLED))
            .appendTo('#browser-check');
    }
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) {
        $('html').addClass('ios');
    }
    if (navigator.appVersion.indexOf('Win') !== -1) {
        $('html').addClass('win-os');
    }

    if (navigator.userAgent.indexOf('Mac') !== -1) {
        $('html').addClass('mac-os');
    }

    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }
    // load js specific styles
    util.limitCharacters();
    // load the off canvas dialog containers
    offcanvasdialog.removeDefaultContainers();
    offcanvasdialog.loadContainers();

    addMaximumScaleToViewport.init();
};
